<template>
  <div>
    <p
      class="menu-label"
    >
      {{ $t(sectionHeader) }}
    </p>
    <ul
      class="menu-list"
    >
      <menu-item
        v-for="item in menuItems"
        :key="item.name"
        v-bind="item"
        :name="item.name"
      />
    </ul>
  </div>
</template>

<script>
  import MenuItem from "./MenuItem";

  export default {
    name: "MenuSection",
    components: { MenuItem },
    props: {
      sectionHeader: {
        type: String,
        default: ''
      },
      menuItems: {
        type: Array,
        default: null
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import "../../assets/styles";

  .menu-label {
    color: nth(map_get($colors, 'brand'), 2);
    margin-top:1em;
    margin-bottom: 0.25em;
  }
</style>
